export default __webpack_public_path__ + "25e54ebe415dd20549cf3dd4cc4ffd50.png";